// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subjects-wrapper {\n  max-height: 600px;\n  overflow: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
